const Types = {
  SEARCH: 'search',
  VIDEO_LIST: 'videoList',
  THEME: 'theme',
  AUTH: 'auth',
  LOGOUT: 'logout',
};

export default Types;
